import styled from 'styled-components';

import { Button } from '_components/_core';
import { CustomSelectField } from '_components/Financial/BankStatement/Reconcile/components';

export const StyledTable = styled.table`  
  &&& {
    font-size: 14px;

    border-collapse: separate;
    border-spacing: 0 10px;

    thead tr th {
      font-size: 13px;
      font-weight: 600;
      padding: .4rem 1rem;
      padding: 8px;
      color: #78829d;
    }
  
    thead tr th:first-child {
      border-left: none;
    }

    tbody tr td {
      padding: .75rem 1rem;
      vertical-align: middle;
      font-weight: 400;
      border: 1px solid rgba(0, 48, 185, 10%);
      margin-top: 8px !important;
      border-right: none;
      border-left: none;
      height: 56.8px;
      background: linear-gradient(0deg, rgba(0, 48, 185, 2.5%), rgba(0, 48, 185, 2.5%)), #ffffff;
    }

    tbody tr:hover td {
      background: linear-gradient(0deg, rgba(0, 48, 185, 5%), rgba(0, 48, 185, 5%)), #ffffff;
    }    

    tbody tr.clear td {
      border: none;
      background-color: transparent;
      height: auto !important;
    }

    tbody tr.clear:hover {
      background-color: transparent;
    }

    tbody tr td:first-child {      
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      border-left: 1px solid rgba(0, 48, 185, 10%);
    }

    tbody tr td:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-right: 1px solid rgba(0, 48, 185, 10%);
    }

    tbody tr.clear td:first-child {
      border-left: none;
    }

    tbody tr.clear td:last-child {
      border-right: none;
    }

    tfoot tr td {
      padding: .75rem 1rem;
      
      font-weight: 600;
    }

    .table-dre {
      tbody tr td {
        background-color: #F9F9F9;
      }
    }
  }
`;

export const StyledUser = styled.span`
  border-bottom: 1px dashed #ccc;
`;

export const RecipientSelect = styled(CustomSelectField)`
  min-width: 15%;
  margin-right: 12px;

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    margin-top: 8px;
  }
`;

export const StyledButton = styled(Button)`
  font-size: 14px;
  font-weight: 500;
  border: none;
  background-color: #f8f9fa;
  color: rgb(7, 20, 55) !important;
  
  &:hover {
    color: #fff !important;
  }
`;

export const FiltersCount = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: red;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
